import React from 'react';
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import { apiPost } from '../services/apiClient';
import './importInvoicesModal.css';

export default class ImportCostsModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            isBusy: false,
			hasImports: false,
            title: "Загрузка фактической стоимости из Excel",
			file: null,
			importResult: null,
			errorMessage: null,
			dragOver: false,
            promiseResolve: null,
            promiseReject: null
        };

		this.infoModal = null;
    }

    open() {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
				isBusy: false,
				hasImports: false,
				file: null,
				importResult: null,
				errorMessage: null,
				dragOver: false,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }
	
	onDrop(files) {
		if(files && files.length > 0) {
			this.setState({
				file: files[0],
				isBusy: true,
				errorMessage: null,
				importResult: null
			}, () => {
				let data = new FormData();
				data.append('file', this.state.file);
				apiPost('parcels/actualCosts/importExcel', data)
					.then(result => {
						this.setState({
							importResult: result,
							hasImports: true,
							isBusy: false
						});
					})
					.catch(err => {
						this.setState({
							errorMessage: err.message,
							isBusy: false
						});
					});
			});
		}
	}

    close() {
		if (this.state.hasImports) {
			this.state.promiseResolve();
		} else {
			this.state.promiseReject();
		}
        this.setState({
            isOpen: false,
			file: null,
			dragOver: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

	renderDropzoneBody() {
		if (this.state.file == null) {
			return (
				<div className="dropzone-small-label">
					<span>Перенесите файл на эту область<br/><b>или</b><br/>нажмите для открытия диалога выбора файла.</span>
				</div>
			);
		} else {
			return (
				<div className="dropzone-small-label">
                    <img src="/img/file_icon.png" className="dropzone-small-icon" alt="file" />
					<span>{this.state.file.name}</span>
				</div>
			);
		}
	}

	renderImportStatus() {
		if (this.state.importResult) {
			return (
				<div className="file-import-status">
					Успешно обработано <b>{this.state.importResult.successRows}</b> записей из <b>{this.state.importResult.totalRows}</b>
				</div>
			);
		} else {
			return null;
		}
	}

	renderImportResult() {
		if (this.state.errorMessage) {
			return (
				<div className="file-import-messages">
					{this.state.errorMessage}
				</div>
			);
		} else if (this.state.importResult) {
			let entries = this.state.importResult.rowMessages.map((entry, ind, arr) => {
				let key = 'ir-entry-' + ind;
				return (
					<div key={key}>
						<b>({entry.rowNumber})</b> {entry.message}
					</div>
				);
			});
			return (
				<div className="file-import-messages">
					{entries}
				</div>
			);
		} else if (this.state.isBusy) {
			return (
				<div className="file-import-messages overlay-wrapper">
					<div className="overlay">
						<i className="fa fa-refresh fa-spin"></i>
					</div>
				</div>
			);
		} else {
			return <div className="file-import-messages"></div>;
		}
	}

    render() {
		let dragzoneClass = "dropzone-small has-advanced-upload" + (this.state.dragOver ? " is-dragover" : "");
        return (
			<div>
				<Modal show={this.state.isOpen} 
					onHide={() => this.close(false)} 
					aria-labelledby="ModalHeader" 
					backdrop="static"
				>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>
							{this.state.title}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Dropzone multiple={false}
							onDrop={files => this.onDrop(files)}
							styles={{}}
							className={dragzoneClass}
						>
							{this.renderDropzoneBody()}
						</Dropzone>

						{this.renderImportStatus()}
						{this.renderImportResult()}
					</Modal.Body>
					<Modal.Footer>
						<Modal.Dismiss className='btn btn-default'>
							Закрыть
						</Modal.Dismiss>
					</Modal.Footer>
				</Modal>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/importCostsModal.jsx